import React from 'react';
import { Text } from '../../atoms/Text/Text';
import { Attachment } from '../../molecules/Attachment';
import './AIUserMessageStyles.scss';
const baseClass = 'qmb-ui-ai-user-message';
/**
 * AIUserMessage Component
 * Displays a user-sent message in an AI conversation, with optional read-only attachments.
 * Content is right-aligned within its container.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function AIUserMessage({ message, attachments = [], attachmentsSlot }) {
    return (React.createElement("div", { className: baseClass }, attachmentsSlot !== null && attachmentsSlot !== void 0 ? attachmentsSlot : null,
        !attachmentsSlot && attachments.length > 0 && (React.createElement("div", { className: `${baseClass}__attachments` }, attachments.map((attachment) => (React.createElement(Attachment, { key: attachment.id, id: attachment.id, name: attachment.name, type: attachment.type, status: attachment.status, errorMessage: attachment.errorMessage, readOnly: true }))))),
        React.createElement("div", { className: `${baseClass}__bubble` },
            React.createElement(Text, { variant: "body" }, message))));
}
